(function () {
  var wrap = document.getElementById('dd-home-videos');
  if (!wrap) { window.__ddHomeReady = true; return; }

  var vids = Array.prototype.slice.call(wrap.querySelectorAll('video'));
  if (!vids.length) { window.__ddHomeReady = true; return; }

  var FADE = 1.2;          // crossfade length in seconds (match the CSS transition)
  var current = 0;
  var z = 1;
  var switching = false;

  function ready() { window.__ddHomeReady = true; }
  setTimeout(ready, 7000); // never block the loading screen for long

  function warm(i) {
    var v = vids[i];
    if (v.preload !== 'auto') v.preload = 'auto';
    if (v.readyState === 0) v.load();
  }

  function play(v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function show(v) {
    z += 1;
    v.style.zIndex = z;
    v.classList.add('is-active');
  }

  function next() {
    if (switching) return;
    switching = true;

    var from = current;
    var to = (current + 1) % vids.length;
    var nv = vids[to];

    function go() {
      nv.currentTime = 0;
      play(nv);
      show(nv);
      current = to;
      setTimeout(function () {
        vids[from].classList.remove('is-active');
        vids[from].pause();
        warm((to + 1) % vids.length);
        switching = false;
      }, FADE * 1000 + 150);
    }

    if (nv.readyState >= 3) {
      go();
    } else {
      warm(to);
      nv.addEventListener('canplay', go, { once: true });
    }
  }

  function loop() {
    var v = vids[current];
    if (!switching && vids.length > 1 && v.duration && v.duration - v.currentTime <= FADE) next();
    requestAnimationFrame(loop);
  }

  var first = vids[0];
  first.muted = true;
  if (vids.length === 1) first.loop = true;

  function begin() {
    play(first);
    show(first);
    ready();
    if (vids.length > 1) warm(1);
    requestAnimationFrame(loop);
  }

  first.preload = 'auto';
  if (first.readyState >= 3) {
    begin();
  } else {
    first.addEventListener('canplay', begin, { once: true });
    first.load();
  }
})();